import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import { ProductCardRedesignTestData, UseProductCardRedesign } from "./types";

const CUSTOM_RULE_ID = "productCardRedesignTest";

const useProductCardRedesign: UseProductCardRedesign = () => {
  const { isLoading, value } = useMonarchRule<{
    data: ProductCardRedesignTestData;
  }>(CUSTOM_RULE_ID, {});

  // Render control on SSR and while Monarch loads so product cards appear in HTML.
  if (isLoading) {
    return {
      isLoading: false,
      variant: "control",
      data: {
        showRedesign: false,
      },
    };
  }

  const variant = value?.data?.showRedesign ? "test" : "control";

  return {
    isLoading,
    variant,
    data: value?.data,
  };
};

export default useProductCardRedesign;
